'use strict';

angular.module('programme')

.directive('insetParagraph', function ()
{
    function link ($scope, element)
    {
        $scope.ctrl.setFocusRequestHandler(function ()
        {
            element.find('p')[0].focus();
        });
    }

    return {
        restrict: 'A',
        templateUrl: 'modules/programme/editor-components/inset-paragraph/insetParagraph.html',
        link: link,
        controller: function($scope)
        {
            $scope.data.rightToLeft = $scope.data.rightToLeft || false;
            $scope.data.image = $scope.data.image || [{type: 'image'}];
        }
    };
});
